export default __webpack_public_path__ + "static/media/ZoomOut_03.43bea007.png";